import styled, { keyframes } from "styled-components";


const expansion = () => keyframes`
 0% {
  box-shadow: 0 0 0 0px rgba(255,0,0,.5);
 }
 100% {
  box-shadow: 0 0 0 5px rgba(255,0,0,.5);
 }
`

export const FlorenzTextArea = styled.div`
  width: -webkit-fill-available;
  .input-container {
    background-color: ${({disabled}) => disabled ? "#CFD3DD" : "#F0F0FF"};
    border: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-width: 100px;
    position: relative;
    padding: 17px 20px;
    border-radius: 20px;
    border-bottom: 2px solid #DADAFD;    
    cursor: ${({disabled}) => disabled ? '' : 'text'};
    .icon-input-form {
      font-size: 14px;
      margin-right: 5px;
    }
    .icon-input-pass {
      margin-bottom: -5px;
      font-size: 14px;
      cursor: pointer;
    }
    .numeral {
      color: ${({disabled}) => disabled ? "##3E3E5B" : "#707582"};
      font-size: 13px;
      margin-right: 8px;
    }
    &:focus-within {
      .numeral {
        color: #2A28D6;
      }
    }
    textarea {
      border: none;
      background-color: transparent;
      width: 100%;
      font-family: "Nunito Sans Light";
      height: 100px;
      resize: none;
      color: ${({theme, textColor}) => textColor ? textColor : theme.inputText};
      &:focus {
        outline: none;
      }
      &::placeholder { 
        color: ${({ theme, placeholdertextcolor }) => placeholdertextcolor ? placeholdertextcolor: theme.inputPlaceholder};
        font-size: ${({fontSize}) => fontSize ? fontSize :'14px'};
        margin-left: 30px;
        font-family: "Nunito Sans Light";
      }
      /* &::-webkit-scrollbar {
        height: 4px;
        width: 20px;
        margin: 0;
        opacity: .9;
        padding-bottom: 10px;
        cursor: pointer;
      } */
      ::-webkit-scrollbar-track {
        min-height: 5px !important;
      }
      ::-webkit-scrollbar-thumb {
        min-height: 30px !important;
      }
    }
    .mic-container {
      color: transparent;
      position: absolute;
      right: 7px;
      bottom: 7px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      animation: ${({activedMic}) => activedMic ? expansion() : null} 2s ease infinite;
      cursor: pointer;
      display: flex;
      .mic-icon {
        color: ${({activedMic, theme}) => !activedMic ? theme.primaryColor : theme.warning};
        margin: 3px auto;
      }
    }
  }
`